<template>

  <div>

    <div @click="alert = false; msgAlert='';" transition="slide-y-transition">
      <v-alert transition="slide-y-transition" v-model="alert" dismissible outline type="warning">
        {{ msgAlert }}
      </v-alert>
    </div>

    <v-toolbar flat>

      <v-toolbar-title class="font-weight-light headline">{{ title }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-dialog v-model="dialog" max-width="700px">

        <v-btn :disabled="loading" :loading="loading" slot="activator" color="info" round icon
          title="Inserir um novo serviço">
          <v-icon>add</v-icon>
        </v-btn>

        <v-card>
          <v-toolbar color="white" class="elevation-3">
            <v-toolbar-items>
              <v-btn @click="resetForm()" title="Cancelar" color="error" icon round flat>
                <v-icon large>remove</v-icon>
              </v-btn>
            </v-toolbar-items>
            <v-spacer></v-spacer>
            <v-toolbar-title class="font-weight-light headline">{{ formTitle }}</v-toolbar-title>
          </v-toolbar>

          <v-card-text>
            <v-form lazy-validation ref="form">
              <v-container fluid grid-list-xl>
                <v-layout wrap row>
                  <v-flex xs12>
                    <v-text-field v-model="officceEdit.description" :rules="inputRules" label="Descrição" autofocus>
                    </v-text-field>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-btn :loading="loading" :disabled="loading" color="success lighten-1" block round @click="save();">Salvar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-toolbar>

    <v-data-table rows-per-page-text="Colunas por página" :loading="loading" :headers="headers" :items="officces"
      class="elevation-1">
      <template slot="items" slot-scope="props">
        <td class="text-xs-center">{{ props.item.description }}</td>
        <td class="justify-center layout px-0 text-xs-center">
          <v-btn :disabled="loading" @click="edit(props.item)" title="Editar registro" color="info" flat icon round>
            <v-icon>edit</v-icon>
          </v-btn>
          <v-btn :disabled="loading" @click="officceRemove = props.item; dialogRemove = true;" title="Excluir registro"
            color="error" flat icon round>
            <v-icon>delete</v-icon>
          </v-btn>
        </td>
      </template>

      <template slot="footer" v-if="calculatedRecords > 0">
        <td colspan="100%">
          <strong class="font-weight-light"> {{ footerText }} {{ calculatedRecords }} </strong>
        </td>
      </template>

      <template slot="no-data" v-else>
        <strong class="font-weight-light"> {{ dynamicFooterText }} </strong>
      </template>

      <template slot="pageText" slot-scope="props" class="font-weight-light">
        Linhas {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
    </v-data-table>

    <v-layout row justify-center>
      <v-dialog v-model="dialogRemove" max-width="290">
        <v-card>
          <v-card-title class="headline">Excluir Registro</v-card-title>

          <v-card-text>
            <span>Descrição: {{ officceRemove.description }}</span>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn color="green darken-1" flat="flat" @click="remove();">
              Sim
            </v-btn>

            <v-btn color="green darken-1" flat="flat" @click="dialogRemove = false">
              Não
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
  import OfficceService from "../service/OfficceService";

  export default {

    data: () => ({
      alert: false,
      msgAlert: "",
      title: "Listagem de Serviços",
      footerText: "Total de registos: ",
      emptyRecordsText: "Nenhum registro encontrado",
      loadingRecordsText: "Carregando registros...",
      loading: false,
      dialog: false,
      dialogRemove: false,
      confirmedExclusion: false,
      isEditing: false,
      officceRemove: {},
      officceEdit: {},
      officces: [],
      officce: {},
      /**********\
      ***Rules***
      \**********/
      inputRules: [
        v => !!v || 'Campo obrigatório',
      ],
      headers: [{
          text: "Descrição",
          align: "center",
          value: "description",
          sortable: true
        },
        {
          text: "",
          align: "center",
          value: "description",
          sortable: false
        }
      ]
    }),

    computed: {
      formTitle() {
        return this.isEditing ? "Editar Serviço" : "Criar Serviço";
      },
      dynamicFooterText() {
        let text = `${this.loading ? this.loadingRecordsText : this.emptyRecordsText}`;
        return text;
      },
      calculatedRecords() {
        let amount = 0;
        for (let i = 0; i < this.officces.length; i++) {
          amount++;
        }
        return amount
      }
    },

    watch: {
      dialog(val) {
        val || this.initialize();
      }
    },

    created() {
      this.initialize();
    },

    methods: {
      async initialize() {
        this.loading = true;
        try {
          this.officces = await OfficceService.getAll();
          this.isEditing = false;
          this.dialog = false;
          this.dialogRemove = false;
          this.officce = {};
          this.officceEdit = {};
          this.officceRemove = {};
          this.confirmedExclusion = false;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }

      },

      edit(officceEditing) {
        //this.officceEdit = officceEditing;
        this.officceEdit = Object.assign({}, officceEditing);
        this.isEditing = true;
        this.disabledButtonSave = false;
        this.dialog = true;
      },

      async remove() {
        this.loading = true;
        try {
          await OfficceService.remove(this.officceRemove);
          this.initialize();
          this.msgAlert = "Excluído com sucesso";
          this.alert = true;
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }

      },

      async save() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          try {
            this.officce = this.officceEdit;
            if (this.isEditing) {
              await OfficceService.update(this.officce);
              this.msgAlert = "Alterado com sucesso";
              this.alert = true;
            } else {
              await OfficceService.save(this.officce);
              this.msgAlert = "Salvo com sucesso";
              this.alert = true;
            }
          } catch (error) {
            console.log(error);
          } finally {
            this.initialize();
          }
        }
      }, // save()
      resetForm() {
        this.$refs.form.reset()
        this.initialize()
      }
    },

  };

</script>

<style>
</style>



// WEBPACK FOOTER //
// src/pages/Officce.vue